
import { templates } from '../../../mocks/resourcesLibrary';

export default function FeaturedTemplates() {
  const featured = templates.filter((t) => t.isFeatured);

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-amber-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 border border-amber-500/30 rounded-full mb-4">
              <i className="ri-star-line text-amber-400" />
              <span className="text-amber-300 text-sm font-medium">Most Popular</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white">
              Featured <span className="text-amber-400">Templates</span>
            </h2>
          </div>
          <p className="text-lg text-slate-400 max-w-md">
            Our most downloaded templates used by thousands of Australian tradies every month.
          </p>
        </div>

        {/* Featured Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {featured.map((template, index) => (
            <div
              key={template.id}
              className={`group relative rounded-3xl overflow-hidden transition-all duration-500 hover:scale-[1.02] ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={template.image}
                  alt={template.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-transparent" />
              </div>

              {/* Content */}
              <div className={`relative flex flex-col justify-end ${index === 0 ? 'min-h-[480px] p-10' : 'min-h-[260px] p-6'}`}>
                {/* Badges */}
                <div className="flex items-center gap-2 mb-4">
                  <span className="px-3 py-1 bg-amber-500/90 text-white text-xs font-semibold rounded-md">
                    FEATURED
                  </span>
                  <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-md">
                    {template.format}
                  </span>
                </div>

                <h3 className={`font-bold text-white mb-2 ${index === 0 ? 'text-3xl' : 'text-xl'}`}>
                  {template.title}
                </h3>
                <p className={`text-slate-300 mb-5 ${index === 0 ? 'text-base max-w-lg' : 'text-sm line-clamp-2'}`}>
                  {template.description}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 text-sm text-slate-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-download-2-line" />
                      {template.downloads.toLocaleString()}
                    </span>
                    <span>{template.fileSize}</span>
                  </div>
                  <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-slate-900 rounded-full font-medium hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-download-line" />
                    Download
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
